<template>
  <div id="app">
    <router-view />
	<!-- <LoginPop /> -->
  </div>
</template>

<script>
	// import LoginPop from '@/src/components/assembly/LoginPop.vue';
	
  export default {
    name: 'App',
	components:{
		// LoginPop
	},
	// mounted(){
		
	// }
  }
</script>
<noscript>Your browser does not support JavaScript!</noscript>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    min-height: 100vh;
  }
</style>


// WEBPACK FOOTER //
// src/App.vue